import { useEffect } from "react";
import { Outlet, useNavigation } from "react-router-dom";

import NProgress from "nprogress";
import "nprogress/nprogress.css";

export const PageProgress = () => {
  const { state } = useNavigation();

  useEffect(() => {
    NProgress.configure({ showSpinner: false });
  }, []);

  useEffect(() => {
    if (state === "loading") {
      NProgress.start();
    } else {
      NProgress.done();
    }
  }, [state]);

  return <Outlet />;
};
